export function buildSignInUrl({ mode, redirect, profession, campaign } = {}) {
  const params = new URLSearchParams();
  if (mode && mode !== "signup") params.set("mode", mode);
  if (redirect) params.set("redirect", redirect);
  if (profession) params.set("profession", profession);
  if (campaign) params.set("campaign", campaign);
  const query = params.toString();
  const path = mode === "signup" ? "/signup" : "/signin";
  return query ? `${path}?${query}` : path;
}

export const SIGN_IN_PATH = buildSignInUrl();
export const PROFESSIONAL_UPGRADE_PATH = "/for-businesses/pricing?plan=basic";
export const UPGRADE_SIGNUP_PATH = buildSignInUrl({
  mode: "signup",
  redirect: PROFESSIONAL_UPGRADE_PATH,
});
